import * as React from 'react';
import { connect } from 'react-redux';

import IState from '../../../../interfaces/states';

import Widget from './Widget';
import ISettings from './ISettings';
import { IReportSettings } from '../../../../interfaces';

interface IProps {
    widgetId: string,
    settings: ISettings,
    reportSettings: IReportSettings,
}

class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    render() {
        return (
            <Widget {...this.props} />
        );
    }
}

const mapStateToProps = (state: IState, props: IProps) => ({
    reportSettings: state.reportSettings,
    settings: (state.reportTemplate.byId[props.widgetId] || {}).settings,
});

export default connect(
    mapStateToProps,
    {}
)(WidgetContainer);


// WEBPACK FOOTER //
// ./src/components/widget/basic/text/WidgetContainer.tsx